import React from 'react';

import TooltipStep from '../TooltipStep';

interface ArticleShareProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const ArticleShare = (props: ArticleShareProps) => (
  <TooltipStep
    {...props}
    title="Share"
    description="Because you're a subscriber, you can share this article with anyone (3 reads)."
  />
);

export default ArticleShare;
